<template>
  <div class="pt20">
    <div class="back" @click="back(false)">
      <img src="@/assets/icons/icon_fh.png" alt="" srcset="">
      <span>{{ $t('bannerManagement.back') }}</span>
    </div>
    <h4>{{ id ? $t('bannerManagement.editBanner') : $t('bannerManagement.createBanner') }}</h4>
    <a-form :form="form" layout="vertical">
      <div class="list">
        <a-form-item class="full" :label="$t('bannerManagement.uploadImage')" :colon="false">
          <Upload @uploadData="uploadData" :fileUrl="form.getFieldValue('bannerUrl')" :accept="['png', 'jpg']" :desc="[$t('bannerManagement.uploadImageDesc1'), $t('bannerManagement.uploadImageDesc2')]" v-decorator="['bannerUrl', { rules: [{ required: true, message: $t('bannerManagement.uploadImageRequired') }] }]"></Upload>
        </a-form-item>
      </div>
      <div class="list">
        <a-form-item class="full" :label="$t('bannerManagement.linkLabel')" :colon="false">
          <a-input
            allowClear
            :placeholder="$t('bannerManagement.linkPlaceholder')"
            v-decorator="['targetUrl', {rules: [{ type: 'url', message: $t('bannerManagement.linkFormatError')}]}]"></a-input>
        </a-form-item>
      </div>
      <div class="submit-button">
        <a-button type="primary" @click="handleSubmit">{{ $t('bannerManagement.save') }}</a-button>
      </div>
    </a-form>
  </div>
</template>

<script>
import { i18nRender } from '@/locales'
import Upload from '@/components/upload/index.vue'

import {
  bannerSave,
  bannerDetail
} from '@/api/admin'
export default {
  components: {
    Upload
  },
  data() {
    return {
      id: undefined,
      form: this.$form.createForm(this)
    }
  },
  methods: {
    back() {
      this.$router.push({
        name: 'bannerList'
      })
    },
    uploadData(data) {
      console.log(data)
      this.form.setFieldsValue({
        bannerUrl: data.length ? data[0].url : ''
      })
    },
    handleSubmit(e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          const data = Object.assign(values, {
            id: this.id
          })
          delete data.repassword
          console.log('Received values of form: ', data)
          bannerSave(data).then(res => {
            if (res.code == 200) {
              const tip = this.id ? i18nRender('bannerManagement.editBanner') : i18nRender('bannerManagement.createBanner')
              this.$message.success(tip + i18nRender('bannerManagement.saveSuccessMsg'))
              this.$router.push({
                name: 'bannerList'
              })
            }
          })
        }
      })
    },
    async getBannerDetail() {
      const res = await bannerDetail({
        id: this.id
      })
      if (res.code == 200) {
        this.form.setFieldsValue({
          bannerUrl: res.data.bannerUrl,
          targetUrl: res.data.targetUrl
        })
      }
    }
  },
  mounted() {
    this.id = this.$route.query.id || undefined
    if (this.id) {
      this.getBannerDetail()
    }
  }
}
</script>

<style lang="less" scoped>
h4{
  font-size: 16px;
  font-weight: 800;
  color: #000000;
  line-height: 22px;
  border-bottom: 1px solid #EDEDED;
  margin-bottom: 20px;
  padding-bottom: 12px;
}
.admin{
  width: 100%;
  cursor: pointer;
  text-align: right;
  margin-bottom: 21px;
  .user-logo{
    width: 26px;
    height: 26px;
    border-radius: 100%;
    margin-right: 12px;
  }
  .down{
    width: 10px;
    margin-left: 5px;
  }
}
/deep/.ant-input-suffix{
  right: 12px;
  img{
    width: 23px;
    cursor: pointer;
  }
}
.back{
  width: 80px;
  height: 34px;
  display: flex;
  cursor: pointer;
  font-size: 14px;
  font-weight: 400;
  color: #000000;
  border-radius: 25px;
  margin-bottom: 26px;
  align-items: center;
  justify-content: center;
  border: 1px solid #D6D6D6;
  img{
    height: 10px;
    margin-right: 9px;
  }
}
/deep/.ant-form{
  .title{
    display: flex;
    font-size: 14px;
    font-weight: 600;
    color: #627587;
    line-height: 20px;
    position: relative;
    padding: 12px 17px;
    margin-bottom: 30px;
    align-items: center;
    border-bottom: 1px solid #EDEDED;
    &::before{
      left: 0;
      content: '';
      width: 4px;
      height: 12px;
      border-radius: 2px;
      position: absolute;
      background: #6B738C;
    }
  }
  .list{
    display: flex;
    // padding-right: 200px;
    .ant-form-item-label label{
      color: #000000;
    }
    .ant-form-item{
      width: 50%;
      padding-left: 45px;
      &:first-child{
        padding-left: 0;
        padding-right: 45px;
      }
    }
    .ant-input-affix-wrapper .ant-input-suffix{
      position: absolute;
      img{
        width: 23px;
        height: 23px;
      }
    }
    .ant-calendar-picker div{
      position: relative;
      .ant-calendar-picker-input{
        width: 228px;
        height: 35px;
        margin-right: 0;
        color: #000000;
        border-radius: 4px;
        background: #FFFFFF;
        border: 1px solid #D8DCE0;
      }

    }
    .ant-input,
    .ant-select{
      border-radius: 4px;
      color: #000000;
    }
    .full .ant-input,
    .full .ant-select{
      width: 100%;
      height: 35px;
      color: #000000;
      margin-right: 0;
      border-radius: 4px;
    }
    .ant-input-wrapper.ant-input-group{
      .ant-input{
        border-right: 0;
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
      }
      .ant-input-group-addon{
        background: #fff;
        font-size: 14px;
        font-weight: 400;
        color: #5E7A92;
        line-height: 20px;
        border-top-right-radius: 20px;
        border-bottom-right-radius: 20px;
      }
    }
  }
  .submit-button{
    width: 100%;
    // padding-left: 500px;
    text-align: center;
  }
}
</style>
